import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  batchId: string;
}

export const useExportScreenshots = () => {
  return useMutation({
    mutationFn: async ({ batchId }: HookProps) => {
      const result = await apiClient.batchesReports.exportScreenshots.mutation({ params: { id: batchId } });
      if (result.status !== 200) throw result.body;

      const href = window.URL.createObjectURL(result.body as Blob);
      const link = document.createElement('a');
      link.href = href;
      const fileName = /filename="(.*)"/.exec(result.headers.get('content-disposition'))[1];
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    onSuccess: () => {
      toast.success('Successfully downloaded the batch screenshots!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error downloading the batch screenshots!');
    },
  });
};
